/* eslint-disable max-len */

export default {
  lang: "Español",
  homeScreen: {
    title: "", // Específico del producto
    stayConnected: "Mantente conectado",
    comingSoon: "Próximamente",
    messages: "Mensajes",
  },
  socialPopup: {
    header: "Enlaces Oficiales",
    videos: "Vídeo de destino",
    socialNetworks: "Redes Sociales",
    officialWebsite: "Sitio Web Oficial",
    officialWebsites: "Sitios Web Oficiales",
  },
  partnerPopup: {
    header: "Socios de la insignia",
    badges: "Estado de la insignia",
    links: "Especializaciones de los socios",
  },
  loginScreen: {
    version2: {
      homeTitle:
        "Vamos a ver si podemos encontrar un perfil existente para ti en nuestro sistema.",
      homeTitleSub:
        "Ingresa la dirección de correo electrónico que normalmente usas para iniciar sesión en los programas de capacitación.",
      noAccount:
        "No se encontró ninguna cuenta ({email}), por favor intenta con otro correo electrónico o crea una cuenta ahora.",
      continueButton: "Continuar",
      success:
        "¡Se ha actualizado tu cuenta con éxito! Serás redirigido en breve a la página de inicio.",
      successNewAccount:
        "Para completar tu registro, recibirás un correo electrónico de confirmación para verificar tu cuenta.",
      loginButton: "Iniciar sesión",
      matchFound:
        "Hemos encontrado una coincidencia, por favor completa tu contraseña para continuar.",
      magicLink:
        "Inicia sesión a través de un enlace en tu correo electrónico:",
      magicLinkButton: "Solicitar enlace mágico",
      magicLinkTitle:
        "Obtén un enlace directo enviado a tu correo electrónico que te conectará instantáneamente.",
      otherEmailButton: "Enviar",
      title:
        "Por favor, toma un momento para completar toda la información a continuación, ya que se utilizará para llenar tu perfil personal y tu información de contacto.",
      titleIndustry:
        "Por favor, toma un momento para completar toda la información a continuación, ya que se utilizará para llenar tu perfil personal y tu información de contacto.",
      register: "Crear una cuenta",
      agent: "Asesor de Viajes",
      visitor: "Visitante de la Industria",
      step1: "Paso 1: Tipo de usuario",
      step2: "Paso 2: Crea una cuenta",
      step3: "Paso 3: Crea tu perfil",
      marketingOptIn:
        "¿Estás seguro de que no estás interesado en mantenerte conectado con el equipo de comercio de viajes de este programa?",
      optIn: "Sí, estoy interesado",
      optOut: "No interesado",
      step2Sub1: "Cuéntanos sobre ti",
      step2Sub2: "Cuéntanos sobre tu negocio",
      privacyHead: "PREFERENCIAS DE COMUNICACIONES",
      privacySub:
        "Marca las casillas a continuación para asegurarte de recibir comunicaciones importantes del equipo de comercio de viajes del proveedor (actualizaciones de productos y anuncios, recompensas, incentivos, FAMs, etc.) e iniciativas de apoyo de ventas y redes de comercio de viajes de TravPRO Mobile.",
      privacy:
        "Protegemos tu privacidad y nunca vendemos, mal utilizamos o traicionamos tu confianza.",
      store: "Descarga fácilmente este programa en tu tienda de aplicaciones:",
      powered: "IMPULSADO POR",
      toastMessage: {
        forgotSuccess:
          "¡Te hemos enviado por correo electrónico un enlace para restablecer tu contraseña! Serás redirigido a la página de inicio de sesión en 10 segundos.",
        emailNotExisting:
          "La dirección de correo electrónico que ingresaste no existe.",
        magicLinkMessage:
          "Por favor espera, te estamos conectando ahora mismo.",
        magicLinkError:
          "No pudimos encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Serás redirigido en 10 segundos.",
        magicLinkError1:
          "No pudimos encontrar un token válido, por favor inicia sesión o solicita un nuevo enlace mágico. Si este problema persiste, contáctanos en: info@travpromobile.com.",
        magicLinkError2:
          "No pudimos encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Serás redirigido en 10 segundos.",
        magicLinkSuccess:
          "Revisa tu correo electrónico en {email}. Tiene un enlace mágico que te conectará.",
        magicLinkErrorWait:
          "Por favor espera 5 minutos entre solicitudes de enlaces mágicos.",
        emailNotFoundError:
          "La dirección de correo electrónico que ingresaste no se encuentra en nuestros registros. Por favor, verifica errores tipográficos o crea una cuenta.",
      },
      errors: {
        zipCodeNotFound: "Código Postal no encontrado, intenta de nuevo",
        zipCodeOnlyNumbers: "El Código Postal solo puede contener números",
        password: "Por favor, ingresa una contraseña",
        passwordNotMatching: "Las contraseñas que ingresaste no coinciden",
        passwordTooShort: "La contraseña debe tener al menos 8 caracteres",
        emailExists:
          "Esta dirección de correo electrónico ya existe o no es válida. Por favor, intenta con otra dirección de correo electrónico o inicia sesión en tu cuenta.",
        fillInAllFields: "Por favor, completa todos los campos requeridos",
        fillInEmail: "Por favor, ingresa tu correo electrónico.",
        emailNotExisting:
          "La dirección de correo electrónico que ingresaste no existe.",
      },
      fields: {
        forgotSubCopy: "¿Olvidaste tu contraseña y quieres cambiarla?",
        forgotSubCopy2:
          "¿Quieres evitar la contraseña por completo? Te enviaremos un correo electrónico con un enlace mágico que te conectará automáticamente al programa.",
        city: "Ciudad",
        companyName: "Nombre de la Empresa",
        role: "Tu Rol",
        description: "¿Cuál describe mejor el negocio de tu empresa?",
        country: "País",
        password: "Contraseña",
        passwordRegister: "Elige una contraseña (mínimo de 8 caracteres)",
        passwordConfirm: "Confirma tu contraseña",
        firstName: "Nombre (Propio)",
        lastName: "Apellido (Familiar)",
        agency: "Nombre de tu Agencia",
        title: "Tu Rol (Selecciona Uno)",
        company: "Nombre de la Empresa",
        select: "Selecciona una opción a continuación",
        state: "Estado",
        province: "Provincia/Región/Estado",
        zipCode: "Código Postal",
        postalCode: "Código Postal",
        affiliate: "¿A qué grupo está principalmente afiliada tu agencia?",
        hostAgency: "¿Tu Agencia Anfitriona?",
        executive: "Ejecutivo",
        management: "Gestión",
        marketing: "Marketing",
        sales: "Ventas",
        coordinator: "Coordinador",
        other: "Otro",
        opt: "Mantente conectado con el equipo de comercio de viajes de este programa y recibe actualizaciones.",
        optMarketing:
          "Mantente conectado con TravPRO respecto a programas y eventos similares.",
        retail: "Tienda Minorista",
        home: "Agente desde Casa",
        independent: "Contratista Independiente",
        host: "Agencia Anfitriona",
        call: "Centro de Llamadas o Agencia en Línea",
        other: "Otro",
        describes: "¿Qué describe mejor a ti y a tu agencia?",
      },
    },
    title:
      "Programa de Capacitación y Habilitación de Ventas para Profesionales de Viajes", // Específico del producto (Texto de TravPRO o ChannelPRO)
    welcome: {
      headerTop: "Bienvenido a",
      headerBottom: "{programName}", // Específico del producto
    },
    sellingPoints: {
      // Todos los puntos de venta pueden ser específicos del producto
      0: "Aprende, Promociona y Vende en Movimiento",
      1: "Capacitación Multimedia a través de Dispositivos",
      2: "Certificado de Finalización",
      3: "Presentaciones de Ventas Preparadas",
      4: "Materiales Promocionales de Alto Impacto",
      5: "Consejos y Promociones Exclusivas",
      6: "Directorio de Productos en Tiempo Real",
      7: "Noticias y Actualizaciones a Tiempo",
    },
    emailPrompt:
      "Por favor, ingresa tu dirección de correo electrónico y contraseña para confirmar que eres un profesional de viajes.", // Texto específico del producto (TravPRO o ChannelPRO)
    tAndC: {
      agree: "Al continuar, aceptas nuestra ",
      privacyPolicy: "política de privacidad",
      and: " y ",
      termsConditions: "términos y condiciones",
    },
    fields: {
      what: "¿Qué tipo de viajes vendes?",
      what1: "¿Cuál es el tipo de viaje #1 que vendes?",
      what2: "¿Cuál es el tipo de viaje #2 que vendes?",
      what3: "¿Cuál es el tipo de viaje #3 que vendes?",
      agency: "Agencia *",
      email: "Correo electrónico",
      password: "Contraseña *",
      passwordConfirm: "Confirma tu contraseña *",
      firstName: "Nombre *",
      lastName: "Apellido *",
      agencyName: "Nombre de la Agencia *",
      city: "Ciudad *",
      stateProvince: "Estado / Provincia *",
      salutation: "Saludo *",
      required: "Requerido",
      invalidEmail: "Correo electrónico no válido",
      opt: "¡Mantente en contacto! Sí, me gustaría optar por recibir comunicaciones de {clientName} que me mantendrán informado sobre noticias, eventos, incentivos, FAM’s y más.",
      complete: "Paso 2: Completa tu perfil",
      tell: "Cuéntanos sobre ti",
      title: "Título Profesional *",
      host: "Nombre de la Agencia Anfitriona",
      country: "País / Región",
      select: "Por favor selecciona una opción a continuación",
      header2: "¿Qué segmento(s) vendes principalmente?",
      step2: "Describe tu Negocio",
      leisure: "De ocio",
      corporate: "Corporativo",
      group: "Grupal",
      affiliate: "¿Cuál es tu afiliación principal?",
      forgot:
        "¿Olvidaste tu contraseña? Haz clic en el botón a continuación y te enviaremos un correo electrónico para restablecer tu contraseña.",
    },
    noAgent: {
      noAgentButton: "No soy un agente",
      title: "Gracias por tu interés en {programName}.", // Específico del producto
      messageWeb:
        "El contenido de este sitio es exclusivamente para profesionales de viajes. \n Para obtener más información sobre {programName}, visita: ", // Específico del producto
      messageMobile:
        "Algunos contenidos de esta aplicación son exclusivamente para profesionales de viajes, pero siéntete libre de explorar una vista previa de lo que esta aplicación tiene para ofrecer presionando 'Continuar'.", // Específico del producto
      continue: "Continuar",
      visitWebsite: "Visitar sitio web",
    },
    newUser: "Usuario Nuevo",
    register: "Registrarse",
    registered: "Este correo electrónico ya está registrado",
    forgot: "Restablecer Contraseña",
    header:
      "Por favor, toma un momento para completar toda la información a continuación, ya que esto es lo que llenará tu perfil e información de contacto.",
    step1:
      "Paso 1: Completa tu dirección de correo electrónico y elige una contraseña.",
  },
  welcomeScreen: {
    title: "Bienvenido a {programName}", // Específico del producto
    helloUser: "Hola {name}",
    hello: "Hola,",
    fromAgency: "de {agency}",
    notUser: "¿No eres {name}?",
    introOnline:
      "¡Entrena inmediatamente en línea o precarga el contenido para que siempre esté disponible para uso sin conexión!",
    introOffline:
      "Ya tienes la última versión precargada. ¡Empieza a entrenar o vender en cualquier momento y lugar!",
    startTraining: "Comienza a aprender",
    continueTraining: "Continúa aprendiendo",
    graduated: "¡Felicidades!",
    downloader: {
      preload: "Precargar",
      stop: "detener",
      init: "Inicializando...",
      lastUpdate: "Última actualización: ",
    },
  },
  trainingScreens: {
    start: "Iniciar",
    continue: "Continuar",
    review: "Revisar",
    restart: "Reiniciar",
    durationInMinutes: "{number} minutos",
    percentageComplete: "{number}% Completado",
    unlock:
      "Desbloquea este capítulo completando el capítulo de entrenamiento {number}.",
    unlockSubtitle:
      "Desbloquea más capítulos completando los capítulos de entrenamiento.",
    allUnlocked: "¡Has desbloqueado todos los capítulos!",
    certificate: "Certificado",
    courseComplete: "Continuar",
    endReached: "Has llegado al final",
    retainEnd:
      "Usa la barra superior para navegar por este capítulo o presiona el botón de atrás para volver al resumen.",
    watchListenRead: "Mira, Escucha y Lee más",
    trouble:
      "Parece que tienes problemas, por favor vuelve a leer el contenido de la(s) página(s) anterior(es) e inténtalo de nuevo.",
    confirm: "Confirma tu respuesta",
    choose: "Por favor elige una respuesta",
    skip: "Regresar >",
    viewAllTitle: "Consejo de Capacitación",
    viewAll:
      "Para proceder a la siguiente página, haz clic en los íconos para ver el contenido suplementario. Videos, mapas y otra información útil han sido proporcionados para mejorar tu capacitación y asegurar que alcances el estado de PRO.",
    fillBlanks: "Rellena el(los) espacio(s) en blanco:",
    next: "Siguiente pregunta",
    retry: "Intentar de nuevo",
    fastTrackText: {
      success:
        "¡Felicidades, has aprobado el curso Fast Track y desbloqueado el resto del entrenamiento!",
      failed:
        "Lamentablemente no aprobaste el curso Fast Track, puedes reanudar tu entrenamiento para obtener tu diploma.",
    },
    fastTrack: "¡Conviértete en un Superstar de Viajes Suizos!",
    fastTrackExplanation:
      '¡Simplemente realiza el cuestionario en las siguientes páginas para tener la oportunidad de ganar un FAM a Suiza!<br><br><span style="font-weight: bold">Encontrarás todas las respuestas a las preguntas del cuestionario de las siguientes maneras:</span><br><br>1.	El contenido que aprendiste en los módulos de Rail Europe y Suiza<br><br>2.	Y en los siguientes sitios web:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">¡Asegúrate de revisar estos recursos en detalle antes de realizar el cuestionario! Solo aquellos con las mejores calificaciones tendrán la oportunidad de ser invitados al FAM.</span>',
    fastTrackButton: "Haz clic aquí para realizar el Quiz de Superstar Suizo",
    grading: "Tu calificación final es: {grade}%",
  },
  nav: {
    home: "Inicio",
    train: "Aprender",
    learn: "Aprender",
    retain: "Retener",
    directory: "Directorio",
    showRoom: "Exhibiciones",
    showcases: "Exhibiciones",
    offers: "Ofertas",
    promote: "Promocionar",
    sell: "Vender",
    info: "Información",
    rewards: "Recompensas",
    media: "Medios",
    favorites: "Favoritos",
    contact: "Conoce al equipo",
    reportCard: "Ver Diploma",
    accountSettings: "Configuración de la Cuenta",
    messages: "Mensajes",
    search: "Buscar",
  },
  contentHeaders: {
    train: "Aprender",
    retain: "Retener",
    subapps: "Módulos de Socios de {programName}",
    maintrainings: "La Fundación",
    subtrainings: "La Experiencia",
  },
  pageDescriptions: {
    train: "Educación, participación y conviértete en el experto.",
    showroom: "",
    retain:
      "¡Felicitaciones por completar tu capacitación! Ahora has desbloqueado tu recurso para retener tu conocimiento experto y habilitar tus esfuerzos de ventas. Utiliza esta área para responder preguntas de productos como un experto o incluso como una presentación de ventas improvisada, en cualquier momento, lugar y desde cualquier dispositivo.",
    promote:
      "Comparte estos elementos para generar interés e iniciar una conversación con clientes y prospectos.",
    sell: "Responde preguntas de clientes y cierra la venta como un profesional con recursos profundos y soporte de ventas dirigido.",
    favorites: "Revisa tu contenido favorito personal",
    search: "Busca en todo el contenido",
    subapps: "",
    maintrainings:
      "Completa estos módulos esenciales para obtener tu certificado.",
    subtrainings:
      "Completa estos módulos sobre todas las cosas increíbles que los clientes pueden hacer y ver en {programName} y recibe tu certificado como Experto Oficial de {programName}.",
  },
  general: {
    reviewRetain: "Revisar y retener",
    microLearning: "Módulo de microaprendizaje",
    marketingShowcase: "Escaparate de marketing",
    viewBadge: "Ver Insignia",
    next: "Siguiente",
    yes: "Sí",
    no: "No",
    previous: "Anterior",
    submit: "Enviar",
    back: "Atrás",
    close: "Cerrar",
    page: "Página",
    search: "Buscar",
    logIn: "Iniciar sesión",
    logOut: "Cerrar sesión",
    viewItem: "Ver {type}",
    imageNotFound: "Imagen no encontrada",
    noResultsFor: "No se han encontrado resultados para: {query}",
    noFavorites: "Aún no tienes favoritos.",
    noMessages: "¡Aún no has recibido mensajes!",
    resultsFor: "Resultados para: {query}",
    showAll: "Mostrar todo",
    connectionError: "Error de conexión",
    alreadyExists: "Ya existe",
    pageNotFound: "¡Página 404 No Encontrada!",
    oops: "Uh oh...",
    overview: "Volver al resumen",
    complete: "Continuar",
    courseComplete: "¡Capítulo Completo!",
    chapterComplete: "¡Capítulo Completado!",
    message: "{count} Mensaje",
    messagePlural: "{count} Mensajes",
  },
  itemTypes: {
    image: "Imagen",
    brochure: "Colección",
    layout: "Diseño",
    web: "Sitio web",
    pdf: "PDF",
    carousel: "Colección",
  },
  questions: {
    dials: "Gira los diales para que coincidan con la respuesta",
    fitb: "Rellena el(los) espacio(s) en blanco",
    flip: "Cambia el número para que coincida con la respuesta",
    multipleChoice: "Elige la(s) respuesta(s) correcta(s)",
    slider: "Elige la respuesta correcta usando el deslizador",
    map: "Responde la pregunta tocando la ubicación correcta en el mapa",
    dropdown: "Elige...",
    true: "Verdadero",
    false: "Falso",
  },
  reportCard: {
    download: "Descargar",
    email: "Correo electrónico",
    print: "Imprimir",
  },
  cookies: {
    consent: "ACEPTAR",
    optout: "Optar por no participar",
    settings: "Configuración de privacidad",
    message:
      "¡No nos has dicho nada sobre tus preferencias de privacidad de datos! Está bien, pero nos gustaría ofrecerte la mejor experiencia utilizando el Sales Companion.",
    disabled: "Parece que has deshabilitado el uso de cookies.",
    use: "La {appName} requiere el uso de cookies para ofrecerte la mejor experiencia.",
    details: "¿Para qué se utilizan las cookies?",
    enable: "Mira cómo habilitar tus cookies {here}.",
    here: "aquí",
  },
  notLoggedIn: {
    super: "No has iniciado sesión",
    title: "Necesitas iniciar sesión para ver este contenido",
    guest: "Invitado",
  },
  demo: {
    message:
      "Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto completo.",
    consent: "¡Entendido!",
  },
  share: {
    header: "¡Comparte este recurso en tu red social favorita!",
    download: "Descargar",
  },
  sharing: {
    copyURL: "Copiar enlace",
    copied: "Copiado",
  },
  breadCrumbs: {
    page: "Página",
  },
  onMobile: {
    header:
      "Parece que estás intentando acceder a la aplicación {appName} desde un dispositivo móvil",
    body: "Para descargar este programa, simplemente visita tu tienda de aplicaciones y busca {appName} o haz clic en uno de los botones a continuación",
    benefits: {
      header: "Esto te proporcionará:",
      1: "Aprende, Promociona y Vende en Movimiento",
      2: "Capacitación Multimedia a través de Dispositivos",
      3: "Certificado de Finalización",
      4: "Presentaciones de Ventas Preparadas",
      5: "Materiales Promocionales de Alto Impacto",
      6: "Directorio de Productos en Tiempo Real",
      7: "Noticias y Actualizaciones a Tiempo",
    },
  },
  directoryView: {
    search: "Buscar...",
    amountOfResults: "Cantidad de resultados:",
    filter: "Filtrar",
    filters: "Filtros:",
    resetFilters: "Restablecer Filtros",
    showResults: "Mostrar Resultados",
    noResults:
      "No se encontraron resultados. Por favor, intenta con otra búsqueda.",
    resetMap: "Restablecer Mapa al Inicio >",
    viewNow: "Ver Ahora >",
  },
  directory: {
    artsentertainment: "Arte y Entretenimiento",
    conventionservices: "Servicios de Convenciones",
    divingsnorkeling: "Buceo y Snorkel",
    film: "Cine",
    hotels: "Hoteles",
    lgbtgymsandspas: "LGBT+: Gimnasios y Spas",
    lgbtshopping: "LGBT+: Compras",
    lgbtwheretostay: "LGBT+: Dónde Hospedarse",
    multiculturaldining: "Multicultural: Restaurantes",
    multiculturalnightlife: "Multicultural: Vida Nocturna",
    nightlife: "Vida Nocturna",
    petfriendly: "Admite Mascotas",
    restaurants: "Restaurantes",
    shopping: "Compras",
    spas: "Spas",
    sports: "Deportes",
    transportation: "Transporte",
    venues: "Lugares",
    waterways: "Vías Fluviales",
    waystoplay: "Maneras de Jugar",
    weddinglocations: "Ubicaciones para Bodas",
    weddingvendors: "Proveedores de Bodas",
  },
  preregisterview: {},
  rewards: {
    rewards: "Recompensas",
    title: "RECOMPENSAS {programName}",
    subTitle:
      "¡Te damos la oportunidad de ganar recompensas por convertirte en un especialista con nuestro programa y reservar viajes a {programName}!",
    body: "¡Reserva viajes a {programName} para tener la oportunidad de ganar! Ingresa tus reservas para ser elegible y ganar una Recompensa de Incentivo Introductoria de una Tarjeta de Regalo Electrónica de $5 US/CAN.",
    item1:
      "Después de tu primera reserva confirmada de 4 noches o más (para una reserva individual) para un mínimo de dos (2) pasajeros, en un hotel o resort calificado. (Los cruceros no califican).",
    item2:
      "La oferta es válida después de completar los Módulos Esenciales del Programa {programName}.",
    link1: "¿Has reservado {programName}? ",
    link2: "Si es así, envía tu reserva aquí.",
    button: "Envía tu reserva",
    bookingForm: {
      title: "RECOMPENSAS {programName}",
      subTitle: "Ingresa tu reserva:",
      required: "* Indica un campo obligatorio",
      email: "Correo Electrónico del Agente",
      agentFirstName: "Nombre del Agente",
      agentLastName: "Apellido del Agente",
      company: "Nombre de la Empresa",
      iata: "IATA/CLIA #",
      stateProvince: "Estado/ Provincia",
      postalCode: "Código Postal",
      country: "País",
      bookingNumber: "Número de Reserva",
      numberOfGuests: "Número de Huéspedes Adultos",
      bookingDate: "Fecha de Reserva",
      tourOperator: "Operador Turístico",
      firstName: "Nombre",
      lastName: "Apellido",
      accommodation: "Nombre del Alojamiento",
      wholesaler:
        "Nombre del Mayorista (si corresponde): si es una reserva directa, ingresa NINGUNO",
      arrivalDate: "Fecha de Llegada",
      departureDate: "Fecha de Salida",
      reservationNumber: "Número de Reserva",
      rooms: "Número de Habitaciones",
      stay: "Duración de la Estancia (en Noches)",
      airline: "Aerolínea/ Transportista (código de 2 dígitos)",
      gateway: "Puerta de Origen (código de aeropuerto de 3 letras)",
      destination: "Destino/ isla (código de aeropuerto de 3 letras)",
      cost: "Costo (solo usa decimales)",
      disclaimer: "* Campos obligatorios",
      button: "Envía tu reserva",
      sub: "Tu información",
      sub2: "Información de la reserva",
    },
    TermsAndConditions: {
      title: "Términos y Condiciones",
      subTitle: "Recompensas Trimestrales de Especialista de las Bahamas",
      body1:
        "Todas las publicaciones deben ir acompañadas de un documento de prueba de venta con saldo cero que corresponda a cada reserva individual que hayas publicado. Los ganadores serán seleccionados en función de la totalidad de documentos de prueba de venta verificados que correspondan a cada reserva listada. Las publicaciones deben seguir todas las reglas de Recompensas de Especialista de las Bahamas para ser elegibles. Los premios no son transferibles y deben canjearse dentro de los tres (3) meses posteriores a la notificación del premio. Cualquier premio no utilizado, no reclamado o rechazado se perderá. Los premios se emitirán trimestralmente y la elegibilidad se verificará en función de los viajes completados.",
      body2:
        "Para ser elegible debes residir en los EE. UU. o Canadá, y ser mayor de edad en el estado, provincia o territorio de residencia. Los empleados de Tour Operator NO son elegibles para sorteos, y NO serán considerados para premios adicionales. Los residentes de la provincia de Quebec NO son elegibles para sorteos, y NO serán considerados para premios adicionales.",
      body3:
        "La emisión de recompensas puede requerir prueba de acreditación como consejero de viajes minorista/de base domiciliaria. Las recompensas disponibles están sujetas a cambios durante el curso del programa.",
      body4: "Privacidad y Uso de Información Personal",
      body5:
        "Los agentes participantes (i) otorgan al Recompensador el derecho de usar su nombre, ciudad, estado, provincia, código postal, confirmación de edad de mayoría, número de teléfono y dirección de correo electrónico para, entre otras cosas, contactar y anunciar a los Ganadores y la provisión de premios; (ii) otorgan al Ganador el derecho de usar su información personal para fines publicitarios y promocionales relacionados con los premios, en cualquier y todos los medios conocidos ahora o en el futuro, sin más compensación a menos que lo prohíba la ley; y (iii) reconocen que los Ganadores pueden divulgar su información personal a agentes y proveedores de servicios de terceros en relación con cualquiera de las actividades enumeradas en (i) y (ii) anteriores.",
      button: "Regresar a la página de inicio",
    },
    thankYouPage: {
      thanks: "Gracias",
      congrats: "Felicitaciones, ",
      body: "tu reserva ha sido recibida y enviada al supervisor de la campaña para su verificación.",
      link: "Ten en cuenta que para ser un ganador, debes haber completado los Módulos Esenciales del Programa de Especialista de las Bahamas",
    },
  },
  custom: {
    splitUsers: "Soy un...",
    brandAmbassador: "Embajador de Marca",
    travelPro: "Profesional de Viajes",
  },
};
